import { Shape } from '@/services/shape';
import {
  addResourceIfNotExists,
  generateLayoutAst,
  insertImages
} from '../utils/resource.utils';
import { JsFileAttribute } from '@/services/shape/attributes/js-file';
import { getRefName } from '../utils/name.utils';
import { buildAstState } from '..';

export const getJsFileAst = (resourceAst: Ast, shape: Shape) => {
  const attrs = shape.attrs as JsFileAttribute;
  const {
    name,
    w = 0,
    h = 0,
    jsFilename,
    jsImgNames,
    format,
    fileRef,
    resources
  } = attrs;
  const layoutAsts: Ast[] = [];
  const jsPreview = resources?.jsPreview;
  if (buildAstState.options.buildFor == 'export') {
    if (!jsFilename) return;
    const isJs = jsFilename.endsWith('.js');
    const isLua = jsFilename.endsWith('.lua');

    const jsFileAst: Ast = {
      tag: 'File',
      attrsMap: {
        fileName: jsFilename,
        name: isJs ? jsFilename.split('/')?.pop() ?? '' : jsFilename
      },
      children: []
    };

    addResourceIfNotExists(resourceAst, jsFileAst, undefined, true);

    // 为解决app上预览图bug，增加一个预览图字段
    if (jsPreview) {
      const imageMap = insertImages(
        resourceAst,
        { jsPreview: jsPreview },
        { recolorEnable: !!attrs.recolorEnable }
      );
      jsFileAst.attrsMap['preview'] = getRefName(imageMap['jsPreview']);
    }

    if (fileRef === 'layout引用') {
      // 生成 layout ast
      const layoutAst: Ast = generateLayoutAst({
        ref: '@' + jsFileAst.attrsMap.name,
        x: attrs.x,
        y: attrs.y
      });
      layoutAsts.push(layoutAst);
    } else {
      const jsWidgetAst: Ast = {
        tag: 'Widget',
        attrsMap: {
          widgetName: name ?? '',
          w: String(w),
          h: String(h)
        },
        children: []
      };

      // 添加widget类型
      jsWidgetAst.attrsMap.jumpApp = isJs
        ? 'jsApplication'
        : isLua
        ? 'luaApplication'
        : '';
      jsWidgetAst.attrsMap.args = '@' + jsFileAst.attrsMap.name;

      // 添加预览图
      const imageMap = insertImages(resourceAst, attrs.resources, {
        recolorEnable: attrs.recolorEnable,
        imgFormat: format
      });
      if (isJs) {
        jsWidgetAst.attrsMap.bg = getRefName(imageMap['jsPreview']);
      } else {
        jsWidgetAst.children.push({
          tag: 'Item',
          attrsMap: {
            x: '0',
            y: '0',
            ref: getRefName(imageMap['jsPreview'])
          },
          children: []
        });
      }
      const ast = addResourceIfNotExists(resourceAst, jsWidgetAst);

      // 生成 layout ast
      const layoutAst: Ast = generateLayoutAst({
        ref: '@' + ast.attrsMap.name,
        x: attrs.x,
        y: attrs.y
      });
      layoutAsts.push(layoutAst);
    }

    jsImgNames?.forEach((filename) => {
      const jsImgAst: Ast = {
        tag: 'File',
        attrsMap: {
          fileName: filename,
          name: isJs
            ? filename.split('/')?.pop()?.split('.')?.[0] + '.bin'
            : filename
        },
        children: []
      };
      addResourceIfNotExists(resourceAst, jsImgAst, undefined, true);
    });
  } else {
    // 编辑器使用时，仅添加预览图
    const imageMap = insertImages(resourceAst, attrs.resources, {
      recolorEnable: attrs.recolorEnable,
      imgFormat: format
    });
    // 生成 layout ast
    const layoutAst: Ast = generateLayoutAst({
      ref: getRefName(imageMap['jsPreview']),
      x: attrs.x,
      y: attrs.y
    });
    layoutAsts.push(layoutAst);
  }
  return layoutAsts;
};
